// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- THEME VARIABLES --- */
:root {
  --bg-app: #0f0f0f;           /* Deepest background */
  --bg-panel: #181818;         /* Primary panel color */
  --bg-sidebar: #1e1e1e;       /* Slightly lighter sidebar */
  --bg-central: #121212;       /* Workspace area */
  --border-color: #2b2b2b;     /* Subtle borders */
  --text-main: #e1e1e1;        /* Primary text */
  --text-dim: #888888;         /* Muted text */
  --accent: #3d5afe;           /* Tractum Brand Blue */
  --row-hover: rgba(255, 255, 255, 0.05);
}

.tractum-ui {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: var(--bg-app);
  color: var(--text-main);
  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.middle-row {
  display: flex;
  flex: 1 1;
}

/* --- PANELS --- */
.top-panel {
  background: var(--bg-panel);
  border-bottom: 1px solid var(--border-color);
  padding: 10px;
}

.left-panel, .right-panel {
  background: var(--bg-sidebar);
  border-right: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.central-panel {
  flex: 1 1;
  background: var(--bg-central);
  padding: 10px;
}

.bottom-panel {
  background: var(--bg-panel);
  height: 80px;
  padding: 10px;
  border-top: 1px solid var(--border-color);
}


/* --- STATUS BAR --- */
.status-bar {
  width: 100%;
  height: 24px;
  background-color: #000; /* Keeping it pure black as requested */
  color: var(--text-dim);
  font-size: 11px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  border-top: 1px solid var(--border-color);
  z-index: 99999 !important;
}

/* --- DATA TABLES / LISTS --- */
th {
  background: #1a1a1a;
  color: var(--text-dim);
  font-weight: 600;
  border-bottom: 1px solid var(--border-color);
}

.sticky-col {
  position: sticky;
  left: var(--col-left, 0);
  width: var(--col-width, auto);
  background: var(--bg-central); /* Matches central panel */
  z-index: 2;
}

.col-resizer {
  background: transparent;
}
.col-resizer:hover {
  background: var(--accent); /* Blue highlight on hover */
  width: 2px;
}

.panel-content, .namespace-list {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}

/* Custom Scrollbar for Dark Theme */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: var(--bg-app);
}
::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #444;
}
`, "",{"version":3,"sources":["webpack://./src/TractumUI/TractumUI1.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,iBAAiB,YAAY,uBAAuB;EACpD,mBAAmB,UAAU,wBAAwB;EACrD,qBAAqB,QAAQ,6BAA6B;EAC1D,qBAAqB,QAAQ,mBAAmB;EAChD,uBAAuB,MAAM,mBAAmB;EAChD,oBAAoB,SAAS,iBAAiB;EAC9C,mBAAmB,UAAU,eAAe;EAC5C,iBAAiB,YAAY,uBAAuB;EACpD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,+BAA+B;EAC/B,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,yCAAyC;AAC3C;;;AAGA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE,uCAAuC;EAC/D,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;EAC7B,6BAA6B,EAAE,0BAA0B;EACzD,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/* --- THEME VARIABLES --- */\n:root {\n  --bg-app: #0f0f0f;           /* Deepest background */\n  --bg-panel: #181818;         /* Primary panel color */\n  --bg-sidebar: #1e1e1e;       /* Slightly lighter sidebar */\n  --bg-central: #121212;       /* Workspace area */\n  --border-color: #2b2b2b;     /* Subtle borders */\n  --text-main: #e1e1e1;        /* Primary text */\n  --text-dim: #888888;         /* Muted text */\n  --accent: #3d5afe;           /* Tractum Brand Blue */\n  --row-hover: rgba(255, 255, 255, 0.05);\n}\n\n.tractum-ui {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background-color: var(--bg-app);\n  color: var(--text-main);\n  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n}\n\n.middle-row {\n  display: flex;\n  flex: 1;\n}\n\n/* --- PANELS --- */\n.top-panel {\n  background: var(--bg-panel);\n  border-bottom: 1px solid var(--border-color);\n  padding: 10px;\n}\n\n.left-panel, .right-panel {\n  background: var(--bg-sidebar);\n  border-right: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.central-panel {\n  flex: 1;\n  background: var(--bg-central);\n  padding: 10px;\n}\n\n.bottom-panel {\n  background: var(--bg-panel);\n  height: 80px;\n  padding: 10px;\n  border-top: 1px solid var(--border-color);\n}\n\n\n/* --- STATUS BAR --- */\n.status-bar {\n  width: 100%;\n  height: 24px;\n  background-color: #000; /* Keeping it pure black as requested */\n  color: var(--text-dim);\n  font-size: 11px;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  border-top: 1px solid var(--border-color);\n  z-index: 99999 !important;\n}\n\n/* --- DATA TABLES / LISTS --- */\nth {\n  background: #1a1a1a;\n  color: var(--text-dim);\n  font-weight: 600;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.sticky-col {\n  position: sticky;\n  left: var(--col-left, 0);\n  width: var(--col-width, auto);\n  background: var(--bg-central); /* Matches central panel */\n  z-index: 2;\n}\n\n.col-resizer {\n  background: transparent;\n}\n.col-resizer:hover {\n  background: var(--accent); /* Blue highlight on hover */\n  width: 2px;\n}\n\n.panel-content, .namespace-list {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n/* Custom Scrollbar for Dark Theme */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n::-webkit-scrollbar-track {\n  background: var(--bg-app);\n}\n::-webkit-scrollbar-thumb {\n  background: #333;\n  border-radius: 4px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #444;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
